import { HGO_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/categories
    */
    getCategories: function(options){
        return axios.get( HGO_CONFIG.API_URL + '/categories',{
            params:{
                offset:options.offset,
                itemsPerPage:options.itemsPerPage,
                orderBy:options.orderBy,
                orderDirection:options.orderDirection,
                showDeleted:options.showDeleted,
        }});
    },

    /*
        GET     /api/categories/search
    */
   searchCategories: function(options){
    return axios.get( HGO_CONFIG.API_URL + '/categories/search',{
        params:{
            showDeleted:options.showDeleted,
            filterableHeaders:options.filterableHeaders,
            q:options.q
    }});
},

    /*
		POST 	/api/categories
	*/
    postAddNewCategory: function( name,description,icon){
        return axios.post( HGO_CONFIG.API_URL + '/categories',
            {
                name: name,
                description:description,
                icon:icon
            }
        );
    },

    /*
		GET 	/api/categories/{slug}/edit
	*/
    getCategoryEdit: function( slug ){
		return axios.get( HGO_CONFIG.API_URL + '/categories/' + slug + '/edit' );
	},


    /*
		PUT 	/api/categories/{slug}
	*/
    putEditCategory: function(slug, name,description,icon){
        return axios.put( HGO_CONFIG.API_URL + '/categories/'+ slug,
            {
                name: name,
                description:description,
                icon:icon
            }
        );
    },

     /*
		GET 	/api/categories/reactivate/{slug}
	*/
    putReactivateCategory: function(slug){
        return axios.get( HGO_CONFIG.API_URL + '/categories/reactivate/' + slug);
    },

    /*
		DELETE /api/categories/{slug}
	*/
    deleteCategory: function( slug ){
		return axios.delete( HGO_CONFIG.API_URL + '/categories/' + slug );
    },
    
    /*
		DELETE /api/categories/{slug}/force
	*/
    forceDeleteCategory: function( slug ){
		return axios.delete( HGO_CONFIG.API_URL + '/categories/' + slug + '/force' );
	}
}